/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  Button,
  Typography,
  Input,
  Slider,
  withStyles,
  makeStyles,
} from "@material-ui/core";
import { HiOutlineX } from "react-icons/hi";
// import CompetitorSelectorComponent from "./CompetitorSelectorComponent";

const useStyles = makeStyles((theme) => ({
  sliderMainContainer: {
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "3px",
    padding: "10px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    height: "100%",
  },
  sliderContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
  },
  slider: {
    alignItems: "center",
    display: "flex",
    marginTop: "5px",
    width: "300px",
    flexDirection: "row",
    position: "relative",
  },
  productPrice: {
    width: "100px",
    position: "absolute",
    top: "-12px",
    left: "calc(50% - 50px)",
    textAlign: "center",
  },
  sliderInput: {
    width: "50px",
    border: "1px solid #4e4e4e",
    "& > input": {
      textAlign: "center",
    },
    "&:before": {
      borderBottom: "none",
    },
    "&:first-child": {
      marginRight: "15px",
    },
    "&:last-child": {
      marginLeft: "15px",
    },
  },
  deleteButtonContainer: {
    minWidth: "18px",
    height: "18px",
    padding: "0",
    "& :first-child": {
      width: "100%",
      height: "100%",
    },
    "& :hover": {
      backgroundColor: "#e2e2e2",
      cursor: "pointer",
    },
  },
  selectedOptionContainer: {
    ...theme.box,
    alignItems: "center",
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    display: "flex",
    width: "70%",
  },
  selectedOptionLabel: {
    alignItems: "inherit",
    display: "inherit",
    overflow: "hidden",
  },
}));

const PrettoSlider = withStyles({
  root: {
    height: 8,
    margin: " 0 15px",
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -6,
    marginLeft: -10,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50%) -2px",
  },
  track: {
    height: 6,
    borderRadius: 4,
  },
  rail: {
    height: 6,
    borderRadius: 4,
  },
})(Slider);

const CompetitorSliderComponent = ({
  sliderValue,
  onValueChange,
  onDeleteCompetitor = () => {},
  productPrice,
  selectedOption,
  minValue,
  maxValue,
  // onChangeCompetitor,
  // totalLabelOptions,
  // categoryId,
  // unshowedCompetitors,
}) => {
  const classes = useStyles();

  const handleValueChange = (event) => {
    const numberInput = Number(event.target.value);
    if (event.target.value === "" || event.target.value === "-") {
      onValueChange(selectedOption, event.target.value);
    } else if (
      Number.isNaN(numberInput) === false &&
      numberInput >= minValue &&
      numberInput <= maxValue
    ) {
      onValueChange(selectedOption, numberInput);
    }
  };

  return (
    <Box component="div" className={`${classes.sliderMainContainer} `}>
      <Box component="div" className={classes.sliderContainer}>
        <Box role="presentation" className={classes.selectedOptionContainer}>
          <Box className={classes.selectedOptionLabel}>
            <Typography variant="body2">{selectedOption.label}</Typography>
          </Box>
        </Box>
        <Box className={classes.slider}>
          <Box className={classes.productPrice}>${productPrice}</Box>
          <Typography variant="body2">{minValue}%</Typography>
          <PrettoSlider
            value={sliderValue}
            onChange={(ev, value) => onValueChange(selectedOption, value)}
            valueLabelDisplay="auto"
            name={selectedOption.key}
            aria-labelledby="range-slider"
            min={minValue}
            max={maxValue}
          />
          <Typography variant="body2">{maxValue}%</Typography>
        </Box>
        <Input
          className={classes.sliderInput}
          value={sliderValue}
          margin="dense"
          onChange={handleValueChange}
          onBlur={handleValueChange}
          inputProps={{
            step: 1,
            min: minValue,
            max: maxValue,
            "aria-labelledby": "input-slider",
          }}
        />
        <Button
          type="text"
          className={classes.deleteButtonContainer}
          onClick={() => onDeleteCompetitor(selectedOption)}
        >
          <HiOutlineX size={10} />
        </Button>
      </Box>
    </Box>
  );
};

export default CompetitorSliderComponent;
